import { getAccounts } from '../../../actions/google/methods/get-accounts'
import { getProperties } from '../../../actions/google/methods/get-properties'

/**
 * Fetches Google accounts and properties with error handling
 * @returns {Promise<Object>} Object containing accounts and properties data or error information
 */
export const getAccountsAndProperties = async () => {
  const result = {
    accounts: [],
    properties: [],
    accountError: null,
    propertyError: null
  }
  
  try {
    result.accounts = await getAccounts()
  } catch (error) {
    result.accountError = 'Google hesabınıza erişilemedi. Lütfen tekrar deneyin.'
  }
  
  if (result.accounts && result.accounts.length > 0) {
    try {
      result.properties = await getProperties()
    } catch (error) {
      result.propertyError = 'Mülkler yüklenirken bir hata oluştu. Lütfen tekrar deneyin.'
    }
  }
  
  return result
}
